import React, { memo } from 'react';
import PropTypes from 'prop-types';

const ActiveDutyPageIncome = ({ width = 97, height = 32, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 77 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g clipPath="url(#clip0_1338_220582)">
        <path
          d="M15.6346 8.36616V9.29503C15.6346 9.33253 15.604 9.36237 15.5673 9.36237H14.6376C14.6009 9.36237 14.5703 9.33253 14.5703 9.29503V8.36616C14.5703 8.32867 14.6009 8.29883 14.6376 8.29883H15.5673C15.604 8.29883 15.6346 8.32867 15.6346 8.36616Z"
          fill="#F5AD34"
        />
        <path
          d="M14.2853 8.29883H13.3564C13.3192 8.29883 13.2891 8.32897 13.2891 8.36616V9.29503C13.2891 9.33222 13.3192 9.36237 13.3564 9.36237H14.2853C14.3225 9.36237 14.3526 9.33222 14.3526 9.29503V8.36616C14.3526 8.32897 14.3225 8.29883 14.2853 8.29883Z"
          fill="#F5AD34"
        />
        <path
          d="M74.1725 19.0501V20.0432H71.4219L71.4487 13.8594H74.1725V14.8694H72.5948V16.4654H73.982V17.4601H72.5948V19.0501H74.1725Z"
          fill="#16293C"
        />
        <path
          d="M69.5905 17.3202L68.8812 20.0402H68.1811L67.4229 17.3163L67.419 20.0402H66.3203V13.8633H67.4229L68.543 17.9147L69.5905 13.8633H70.6693V20.0402H69.5821L69.5905 17.3202Z"
          fill="#16293C"
        />
        <path
          d="M65.7252 14.759V19.1715C65.7252 19.1876 65.719 20.1257 64.3043 20.1257C62.8896 20.1257 62.8398 19.1715 62.8398 19.1715V14.759C62.8398 14.759 62.8773 13.7773 64.3043 13.7773C65.7313 13.7773 65.7252 14.7422 65.7252 14.759ZM64.6272 14.9258C64.6272 14.9258 64.654 14.7682 64.3043 14.759C63.9546 14.7498 63.9715 14.8975 63.9715 14.8975V18.9252C63.9715 18.9252 64.0059 19.1715 64.3043 19.1715C64.6027 19.1715 64.6272 18.9252 64.6272 18.9252V14.9258Z"
          fill="#16293C"
        />
        <path
          d="M64.2219 6.50977L62.9594 10.0998V12.6867H61.7857V10.0317L60.625 6.50977H61.7857L62.407 8.9054L62.9939 6.50977H64.2219Z"
          fill="#16293C"
        />
        <path
          d="M62.2733 17.9321L62.2611 19.0951C62.258 19.3116 62.1861 19.5259 62.0422 19.6881C61.8502 19.9046 61.4906 20.1212 60.8211 20.1212C60.1516 20.1212 59.7836 19.9023 59.5831 19.6843C59.4285 19.5167 59.3497 19.294 59.3497 19.066L59.3359 14.9412C59.3352 14.73 59.3987 14.5211 59.5265 14.352C59.7246 14.0904 60.1095 13.7812 60.8211 13.7812C61.5327 13.7812 61.9037 14.0927 62.0835 14.3559C62.1937 14.5165 62.248 14.7078 62.2488 14.9022L62.2519 15.9925H61.1616V15.0062C61.1616 14.9963 61.1577 14.7698 60.8211 14.7622C60.6489 14.7583 60.5579 14.8195 60.5097 14.8815C60.4737 14.9282 60.4576 14.9879 60.4569 15.0475L60.4354 18.8656C60.4347 18.9681 60.4859 19.066 60.5755 19.1173C60.6328 19.1502 60.7124 19.1755 60.8211 19.177C61.1386 19.1808 61.1424 18.962 61.1424 18.962L61.157 17.9321H62.2733Z"
          fill="#16293C"
        />
        <path
          d="M60.5322 6.50195V7.5433H59.6377V12.6942H58.4716V7.5433H57.5703V6.50195H60.5322Z"
          fill="#16293C"
        />
        <path
          d="M58.7474 13.8633V20.0402H57.6211L56.908 17.1136C56.908 17.1136 56.9027 17.1113 56.9027 17.1143V20.0402H55.7305V13.8633H56.8996L57.6104 16.7035C57.6142 16.718 57.6357 16.7149 57.6357 16.7004V13.8633H58.7474Z"
          fill="#16293C"
        />
        <path
          d="M57.1437 6.46484V11.7527C57.1437 11.7527 57.0282 12.7313 55.6624 12.7313C54.2967 12.7313 54.1972 11.7527 54.1972 11.7527L54.1758 6.46714H55.338V11.4757C55.338 11.5369 55.3663 11.5943 55.4145 11.6318C55.5622 11.7473 55.7673 11.7542 55.9226 11.6502L55.9509 11.631C56.006 11.5943 56.0389 11.5323 56.0389 11.4665V6.46484H57.1437Z"
          fill="#16293C"
        />
        <path
          d="M55.0004 13.8555L55.0188 20.0492H53.832V13.8555H55.0004Z"
          fill="#16293C"
        />
        <path
          d="M53.5806 7.45869C53.5913 8.03025 53.5837 10.7687 53.5814 11.5024C53.5806 11.6593 53.5485 11.8131 53.4842 11.9562C53.3526 12.2477 53.0672 12.67 52.5194 12.67C51.7474 12.67 50.7657 12.6754 50.6211 12.6762V6.51758H52.4054C52.7367 6.51758 53.0626 6.64536 53.3029 6.87413C53.4536 7.01798 53.576 7.21079 53.5806 7.45869ZM52.485 11.3815V7.86192C52.485 7.76322 52.4414 7.66911 52.3671 7.60484C52.3052 7.55128 52.2263 7.5222 52.1452 7.5222H51.7558V11.7113H52.1552C52.2547 11.7113 52.3495 11.6662 52.4115 11.5881C52.459 11.53 52.485 11.4565 52.485 11.3815Z"
          fill="#16293C"
        />
        <path
          d="M51.8952 19.0501V20.0432H49.1445L49.1713 13.8594H51.8952V14.8694H50.3175V16.4654H51.7054V17.4601H50.3175V19.0501H51.8952Z"
          fill="#16293C"
        />
        <path
          d="M48.8299 13.8594L47.8246 20.0432H46.2928L45.2812 13.8594H46.481L47.0403 18.6285H47.0411L47.6654 13.8594H48.8299Z"
          fill="#16293C"
        />
        <path
          d="M48.5983 11.6965V12.6897H45.8477L45.8744 6.50586H48.5983V7.51584H47.0206V9.11191H48.4078V10.1066H47.0206V11.6965H48.5983Z"
          fill="#16293C"
        />
        <path
          d="M45.6026 6.50586L44.598 12.6897H43.0654L42.0547 6.50586H43.2537L43.813 11.2749C43.813 11.2749 43.8145 11.2757 43.8145 11.2749L44.4381 6.50586H45.6026Z"
          fill="#16293C"
        />
        <path
          d="M44.9113 13.8594L44.9297 20.0432H43.7422V13.8594H44.9113Z"
          fill="#16293C"
        />
        <path
          d="M43.1038 19.1383C43.1038 19.1383 43.1505 20.1077 41.6233 20.1077C40.2789 20.1077 40.168 19.1467 40.168 19.1467V17.911H41.2721V18.908C41.2721 18.908 41.2774 19.1482 41.6233 19.1482C41.9691 19.1482 41.9637 18.908 41.9637 18.908V18.263C41.9637 18.0304 41.8788 17.8069 41.725 17.6333C41.5689 17.458 41.3287 17.2377 40.9813 17.038C40.4671 16.7419 40.2896 16.3188 40.2299 16.0976C40.2101 16.0219 40.2009 15.9431 40.2009 15.865V14.764C40.2009 14.764 40.1351 13.7969 41.6233 13.7969C43.1114 13.7969 43.1038 14.7441 43.1038 14.7441V15.9484H41.9714V14.992C41.9714 14.992 41.953 14.7365 41.6233 14.7365C41.3708 14.7365 41.3103 14.992 41.3103 14.992V15.497C41.3103 15.777 41.4335 16.0425 41.6485 16.2224C41.764 16.3195 41.9201 16.4297 42.129 16.5491C42.5942 16.8138 42.8513 17.1543 42.9829 17.3861C43.0632 17.5277 43.1038 17.6876 43.1038 17.8498V19.1383Z"
          fill="#16293C"
        />
        <path
          d="M41.6223 6.50586L41.6406 12.6897H40.4531V6.50586H41.6223Z"
          fill="#16293C"
        />
        <path
          d="M40.0868 6.50586V7.54338H39.1924V12.6897H38.0263V7.54338H37.125V6.50586H40.0868Z"
          fill="#16293C"
        />
        <path
          d="M39.5921 19.1383C39.5921 19.1383 39.6387 20.1077 38.1115 20.1077C36.7672 20.1077 36.6562 19.1467 36.6562 19.1467V17.911H37.7603V18.908C37.7603 18.908 37.7657 19.1482 38.1115 19.1482C38.4574 19.1482 38.452 18.908 38.452 18.908V18.263C38.452 18.0304 38.3671 17.8069 38.2125 17.6333C38.0572 17.458 37.817 17.2377 37.4688 17.038C36.9554 16.7419 36.7779 16.3188 36.7182 16.0976C36.6976 16.0219 36.6892 15.9431 36.6892 15.865V14.764C36.6892 14.764 36.6233 13.7969 38.1115 13.7969C39.5997 13.7969 39.5921 14.7441 39.5921 14.7441V15.9484H38.4597V14.992C38.4597 14.992 38.4405 14.7365 38.1115 14.7365C37.859 14.7365 37.7986 14.992 37.7986 14.992V15.497C37.7986 15.777 37.9218 16.0425 38.1368 16.2224C38.2523 16.3195 38.4084 16.4297 38.6173 16.5491C39.0825 16.8138 39.3396 17.1543 39.4712 17.3861C39.5515 17.5277 39.5921 17.6876 39.5921 17.8498V19.1383Z"
          fill="#16293C"
        />
        <path
          d="M36.8397 10.5778L36.8267 11.7408C36.8244 11.9581 36.7525 12.1716 36.6086 12.3338C36.4166 12.5503 36.057 12.7669 35.3875 12.7669C34.718 12.7669 34.3499 12.5481 34.1495 12.33C33.9949 12.1624 33.9161 11.9398 33.9153 11.7118L33.9023 7.58691C33.9023 7.37574 33.9651 7.16685 34.0929 6.99776C34.291 6.73608 34.6759 6.42773 35.3875 6.42773C36.099 6.42773 36.4701 6.73838 36.6499 7.00159C36.7601 7.16226 36.8144 7.35355 36.8152 7.54789L36.8183 8.63821H35.728V7.65195C35.728 7.642 35.7241 7.41552 35.3875 7.40787C35.2153 7.40405 35.1243 7.46526 35.0761 7.52723C35.0401 7.57467 35.024 7.63359 35.0233 7.69327L35.0018 11.5113C35.0011 11.6138 35.0523 11.7118 35.1419 11.763C35.1992 11.7959 35.2788 11.8212 35.3875 11.8227C35.705 11.8265 35.7088 11.6077 35.7088 11.6077L35.7234 10.5778H36.8397Z"
          fill="#16293C"
        />
        <path
          d="M35.3221 13.873L36.3435 20.0301H35.1767L35.0443 18.7385H34.1346L33.9456 20.0301H32.8086L33.8056 13.873H35.3221ZM34.8974 17.7921L34.5852 16.0147C34.5829 16.0009 34.563 16.0009 34.5608 16.0154L34.2708 17.7921H34.8974Z"
          fill="#16293C"
        />
        <path
          d="M32.5721 6.51953L33.5935 12.6766H32.4267L32.2943 11.385H31.3853L31.1956 12.6766H30.0586L31.0556 6.51953H32.5721ZM32.1474 10.4386L31.8352 8.66115C31.8329 8.64737 31.813 8.64737 31.8108 8.66191L31.5208 10.4386H32.1474Z"
          fill="#16293C"
        />
        <path
          d="M32.9256 14.9141C32.9256 14.9141 32.9355 16.2164 32.9041 16.4781C32.8728 16.7367 32.7243 16.9387 32.3464 17.2317C32.0763 17.4406 31.227 17.4444 31.227 17.4444V20.0061H30.0586V13.8965H31.8505C31.8505 13.8965 32.1115 13.9049 32.5063 14.1352C32.9011 14.3655 32.9256 14.9141 32.9256 14.9141ZM31.8046 16.2301C31.8291 16.0764 31.8046 15.0916 31.8046 15.0916C31.8046 15.0916 31.8245 14.8453 31.6164 14.8453H31.168V16.462H31.5101C31.6164 16.462 31.7197 16.4107 31.7733 16.3189C31.7878 16.2929 31.7993 16.2638 31.8046 16.2301Z"
          fill="#16293C"
        />
        <path
          d="M28.2265 6.62891V8.77435L20.0234 13.9903L20.0433 11.7278L28.2265 6.62891Z"
          fill="#16293C"
        />
        <path
          d="M26.6463 10.7441L26.6188 12.7366L20.0103 16.8668V19.7704L14.4447 24.8165L8.81252 19.7704L8.80105 16.8668L2.21094 12.7366V10.7441L10.4514 15.8285V19.0436L14.4447 22.6489L18.3377 19.0436V15.8285L26.6463 10.7441Z"
          fill="#F5AD34"
        />
        <path
          d="M25.5679 14.209V16.3552L20.4805 19.5818L20.5004 17.3185L25.5679 14.209Z"
          fill="#16293C"
        />
        <path
          d="M22.718 6.61943V9.19946C22.718 9.25915 22.65 9.29358 22.6017 9.25915L14.6757 3.6048C14.5426 3.50992 14.3635 3.50992 14.2304 3.60403L6.25693 9.24231C6.20796 9.27674 6.14062 9.24231 6.14062 9.18187V6.54904C6.14062 6.52455 6.1521 6.5016 6.172 6.48783L14.1952 0.935238C14.3505 0.828119 14.5556 0.828884 14.7101 0.937534L22.6867 6.55898C22.7066 6.57276 22.718 6.59571 22.718 6.61943Z"
          fill="#F5AD34"
        />
        <path
          d="M17.3151 13.8119L15.5354 15.1142L16.2241 17.2083L14.4359 15.9183L12.657 17.2206L13.3311 15.121L11.543 13.8318L13.7473 13.8241L14.4222 11.7246L15.11 13.8195L17.3151 13.8119Z"
          fill="#16293C"
        />
        <path
          d="M15.6346 7.08958V8.01846C15.6346 8.05518 15.604 8.08579 15.5673 8.08579H14.6376C14.6009 8.08579 14.5703 8.05518 14.5703 8.01846V7.08958C14.5703 7.05209 14.6009 7.02148 14.6376 7.02148H15.5673C15.604 7.02148 15.6346 7.05209 15.6346 7.08958Z"
          fill="#F5AD34"
        />
        <path
          d="M14.3526 7.08958V8.01846C14.3526 8.05518 14.3228 8.08579 14.2853 8.08579H13.3564C13.3189 8.08579 13.2891 8.05518 13.2891 8.01846V7.08958C13.2891 7.05209 13.3189 7.02148 13.3564 7.02148H14.2853C14.3228 7.02148 14.3526 7.05209 14.3526 7.08958Z"
          fill="#F5AD34"
        />
        <path
          d="M8.81279 11.7278L8.83269 13.9903L0.628906 8.77435V6.62891L8.81279 11.7278Z"
          fill="#16293C"
        />
        <path
          d="M8.35265 17.3185L8.37254 19.5818L3.28516 16.3552V14.209L8.35265 17.3185Z"
          fill="#16293C"
        />
        <path
          d="M31.0595 6.51953L30.0625 12.6766H31.1995L31.3892 11.385H32.2982L32.4306 12.6766H33.5974L32.576 6.51953H31.0595Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M31.8134 8.66139L31.5234 10.438H32.1501L31.8379 8.66063C31.8356 8.64685 31.8157 8.64685 31.8134 8.66139Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M33.9063 7.58691L33.9193 11.7118C33.92 11.9398 33.9988 12.1624 34.1534 12.33C34.3539 12.5481 34.7219 12.7669 35.3914 12.7669C36.0609 12.7669 36.4205 12.5503 36.6125 12.3338C36.7564 12.1716 36.8283 11.9581 36.8306 11.7408L36.8436 10.5778H35.7273L35.7127 11.6077C35.7127 11.6077 35.7089 11.8265 35.3914 11.8227C35.2827 11.8212 35.2032 11.7959 35.1458 11.763C35.0563 11.7118 35.005 11.6138 35.0058 11.5113L35.0272 7.69327C35.0279 7.63359 35.044 7.57467 35.08 7.52723C35.1282 7.46526 35.2192 7.40405 35.3914 7.40787C35.728 7.41552 35.7319 7.642 35.7319 7.65195V8.63821H36.8222L36.8191 7.54789C36.8184 7.35355 36.764 7.16226 36.6539 7.00159C36.474 6.73838 36.1091 6.42773 35.3914 6.42773C34.6737 6.42773 34.2949 6.73608 34.0968 6.99776C33.969 7.16685 33.9055 7.37574 33.9063 7.58691Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M37.125 6.50586V7.54338H38.0263V12.6897H39.1924V7.54338H40.0868V6.50586H37.125Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M40.4531 6.50586V12.6897H41.6406L41.6223 6.50586H40.4531Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M42.0554 6.50586H43.2537L43.813 11.2749C43.813 11.2749 43.8145 11.2757 43.8145 11.2749L44.4381 6.50586H45.6026L44.598 12.6897H43.0654L42.0547 6.50586H42.0554Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M45.8744 6.50586L45.8477 12.6897H48.5983V11.6965H47.0206V10.1066H48.4078V9.11191H47.0206V7.51584H48.5983V6.50586H45.8744Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M54.1797 6.46519L54.2011 11.7507C54.2011 11.7507 54.3136 12.7293 55.6663 12.7293C57.0191 12.7293 57.1477 11.7507 57.1477 11.7507V6.46289H56.0428V11.4646C56.0428 11.5304 56.0099 11.5924 55.9548 11.6291L55.9265 11.6482C55.7712 11.7523 55.5661 11.7454 55.4184 11.6298C55.3702 11.5924 55.3419 11.535 55.3419 11.4738V6.46519H54.1797Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M60.6289 6.50977H61.7896L62.4109 8.9054L62.9978 6.50977H64.2258L62.9633 10.0998V12.6867H61.7896V10.0317L60.6289 6.50977Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M57.5703 6.50195V7.5433H58.4716V12.6942H59.6377V7.5433H60.5322V6.50195H57.5703Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M50.6211 6.51758V12.6754"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M51.7578 7.52344V11.7126H52.1572C52.2567 11.7126 52.3516 11.6674 52.4135 11.5894C52.461 11.5312 52.487 11.4578 52.487 11.3828V7.86316C52.487 7.76446 52.4434 7.67034 52.3692 7.60607C52.3072 7.55251 52.2284 7.52344 52.1473 7.52344H51.7578Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M50.5977 6.51758H52.4057C52.737 6.51758 53.0629 6.64536 53.3032 6.87413C53.4539 7.01798 53.5763 7.21079 53.5809 7.45869C53.5916 8.03025 53.584 10.7687 53.5817 11.5024C53.5809 11.6593 53.5488 11.8131 53.4845 11.9562C53.3529 12.2477 53.0675 12.67 52.5197 12.67C51.7477 12.67 50.766 12.6754 50.6214 12.6762H50.6038"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M43.7422 13.8594V20.0432H44.9297L44.9113 13.8594H43.7422Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M45.2859 13.8594H46.4849L47.0442 18.6285H47.045L47.6693 13.8594H48.8339L47.8285 20.0432H46.2967L45.2852 13.8594H45.2859Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M49.1752 13.8594L49.1484 20.0432H51.8991V19.0501H50.3214V17.4601H51.7093V16.4654H50.3214V14.8694H51.8991V13.8594H49.1752Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M53.8359 13.8555V20.0492H55.0227L55.0043 13.8555H53.8359Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M59.3399 14.9412L59.3536 19.066C59.3536 19.294 59.4324 19.5167 59.587 19.6843C59.7875 19.9023 60.1555 20.1212 60.825 20.1212C61.4945 20.1212 61.8541 19.9046 62.0461 19.6881C62.19 19.5259 62.2619 19.3116 62.265 19.0951L62.2772 17.9321H61.1609L61.1463 18.962C61.1463 18.962 61.1425 19.1808 60.825 19.177C60.7163 19.1755 60.6368 19.1502 60.5794 19.1173C60.4898 19.066 60.4386 18.9681 60.4393 18.8656L60.4608 15.0475C60.4615 14.9879 60.4776 14.9282 60.5136 14.8815C60.5618 14.8195 60.6528 14.7583 60.825 14.7622C61.1616 14.7698 61.1655 14.9963 61.1655 15.0062V15.9925H62.2558L62.2527 14.9022C62.2527 14.7078 62.1976 14.5165 62.0875 14.3559C61.9076 14.0927 61.5427 13.7812 60.825 13.7812C60.1073 13.7812 59.7285 14.0904 59.5304 14.352C59.4026 14.5211 59.3391 14.73 59.3399 14.9412Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M71.4487 13.8594L71.4219 20.0432H74.1725V19.0501H72.5948V17.4601H73.982V16.4654H72.5948V14.8694H74.1725V13.8594H71.4487Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M30.0586 13.8965V20.0061H31.227V17.4444C31.227 17.4444 32.0763 17.4406 32.3464 17.2317C32.7243 16.9387 32.8728 16.7367 32.9041 16.4781C32.9355 16.2164 32.9256 14.9141 32.9256 14.9141C32.9256 14.9141 32.9011 14.3655 32.5063 14.1352C32.1115 13.9049 31.8505 13.8965 31.8505 13.8965H30.0586Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M31.168 14.8457V16.4624H31.51C31.6163 16.4624 31.7196 16.4112 31.7732 16.3194C31.7877 16.2933 31.7992 16.2643 31.8046 16.2306C31.829 16.0768 31.8046 15.0921 31.8046 15.0921C31.8046 15.0921 31.8245 14.8457 31.6163 14.8457H31.168Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M33.8056 13.873L32.8086 20.0301H33.9456L34.1346 18.7385H35.0443L35.1767 20.0301H36.3435L35.3221 13.873H33.8056Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M34.5634 16.0149L34.2734 17.7916H34.9001L34.5879 16.0141C34.5856 16.0004 34.5657 16.0004 34.5634 16.0149Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M38.4597 15.9484H39.5921V14.7441C39.5921 14.7441 39.6296 13.7969 38.1115 13.7969C36.5935 13.7969 36.6892 14.764 36.6892 14.764V15.865C36.6892 15.9431 36.6976 16.0219 36.7182 16.0976C36.7779 16.3188 36.9554 16.7419 37.4688 17.038C37.817 17.2377 38.0572 17.458 38.2125 17.6333C38.3671 17.8069 38.452 18.0304 38.452 18.263V18.908C38.452 18.908 38.4581 19.1482 38.1115 19.1482C37.7649 19.1482 37.7603 18.908 37.7603 18.908V17.911H36.6562V19.1467C36.6562 19.1467 36.7672 20.1077 38.1115 20.1077C39.6387 20.1077 39.5921 19.1383 39.5921 19.1383V17.8498C39.5921 17.6876 39.5515 17.5277 39.4712 17.3861C39.3396 17.1543 39.0825 16.8138 38.6173 16.5491C38.4084 16.4297 38.2523 16.3195 38.1368 16.2224C37.9218 16.0425 37.7986 15.777 37.7986 15.497V14.992C37.7986 14.992 37.859 14.7365 38.1115 14.7365C38.4405 14.7365 38.4597 14.992 38.4597 14.992V15.9484Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M41.9753 15.9484H43.1077V14.7441C43.1077 14.7441 43.1452 13.7969 41.6272 13.7969C40.1091 13.7969 40.2048 14.764 40.2048 14.764V15.865C40.2048 15.9431 40.214 16.0219 40.2339 16.0976C40.2935 16.3188 40.471 16.7419 40.9852 17.038C41.3326 17.2377 41.5728 17.458 41.7289 17.6333C41.8827 17.8069 41.9676 18.0304 41.9676 18.263V18.908C41.9676 18.908 41.9738 19.1482 41.6272 19.1482C41.2806 19.1482 41.276 18.908 41.276 18.908V17.911H40.1719V19.1467C40.1719 19.1467 40.2828 20.1077 41.6272 20.1077C43.1544 20.1077 43.1077 19.1383 43.1077 19.1383V17.8498C43.1077 17.6876 43.0671 17.5277 42.9868 17.3861C42.8552 17.1543 42.5981 16.8138 42.1329 16.5491C41.924 16.4297 41.7679 16.3195 41.6524 16.2224C41.4374 16.0425 41.3142 15.777 41.3142 15.497V14.992C41.3142 14.992 41.3747 14.7365 41.6272 14.7365C41.9569 14.7365 41.9753 14.992 41.9753 14.992V15.9484Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M55.7305 13.8633V20.0402H56.9027V17.1143C56.9027 17.1143 56.9072 17.1113 56.908 17.1136L57.6211 20.0402H58.7474V13.8633H57.6357V16.7004C57.6357 16.7149 57.6142 16.718 57.6104 16.7035L56.8996 13.8633H55.7305Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M67.4219 17.3105C67.4219 17.3105 67.4219 17.3128 67.4226 17.3151V17.3167L68.1809 20.0406H68.881L69.5903 17.3205V17.319L69.591 17.3151"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M69.5905 17.3202L69.5821 20.0402H70.6693V13.8633H69.5905L68.543 17.9147L67.4229 13.8633H66.3203V20.0402H67.419L67.4229 17.3163"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M62.8438 14.759V19.1715C62.8438 19.1715 62.8812 20.1257 64.3082 20.1257C65.7352 20.1257 65.7291 19.1876 65.7291 19.1715V14.759C65.7291 14.7422 65.723 13.7773 64.3082 13.7773C62.8935 13.7773 62.8438 14.759 62.8438 14.759Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M63.9767 14.8987V18.9263C63.9767 18.9263 64.0111 19.1727 64.3095 19.1727C64.6079 19.1727 64.6324 18.9263 64.6324 18.9263V14.927C64.6324 14.927 64.6592 14.7694 64.3095 14.7602C63.9599 14.751 63.9767 14.8987 63.9767 14.8987Z"
          stroke="#16293C"
          strokeWidth="0.0765135"
          strokeMiterlimit="10"
        />
        <path
          d="M75.7019 15.4467C76.124 15.4467 76.4662 15.1045 76.4662 14.6823C76.4662 14.2602 76.124 13.918 75.7019 13.918C75.2797 13.918 74.9375 14.2602 74.9375 14.6823C74.9375 15.1045 75.2797 15.4467 75.7019 15.4467Z"
          stroke="#16293C"
          strokeWidth="0.229541"
          strokeMiterlimit="10"
        />
        <path
          d="M75.4371 14.9961V14.3389H75.7756C75.8384 14.3389 75.8863 14.3442 75.9195 14.355C75.9527 14.3658 75.9794 14.3858 75.9998 14.4151C76.0201 14.4441 76.0303 14.4795 76.0303 14.5213C76.0303 14.5578 76.0225 14.5893 76.0069 14.6159C75.9914 14.6422 75.97 14.6636 75.9428 14.68C75.9255 14.6905 75.9017 14.6992 75.8715 14.706C75.8958 14.7141 75.9134 14.7222 75.9245 14.7302C75.9319 14.7356 75.9427 14.7471 75.9567 14.7648C75.9711 14.7824 75.9806 14.796 75.9854 14.8056L76.0836 14.9961H75.8541L75.7456 14.7952C75.7318 14.7692 75.7196 14.7524 75.7088 14.7446C75.6942 14.7344 75.6776 14.7293 75.659 14.7293H75.6411V14.9961H75.4371ZM75.6411 14.6052H75.7267C75.736 14.6052 75.7539 14.6022 75.7805 14.5962C75.794 14.5935 75.8049 14.5866 75.8133 14.5756C75.8219 14.5645 75.8263 14.5518 75.8263 14.5375C75.8263 14.5162 75.8195 14.5 75.8061 14.4886C75.7926 14.4772 75.7674 14.4716 75.7303 14.4716H75.6411V14.6052Z"
          fill="#16293C"
        />
        <path
          d="M75.4371 14.9961H75.3989V15.0344H75.4371V14.9961ZM75.4371 14.3389V14.3006H75.3989V14.3389H75.4371ZM75.9998 14.4151L75.9683 14.4369L75.9684 14.437L75.9998 14.4151ZM76.0069 14.6159L76.0399 14.6354L76.04 14.6352L76.0069 14.6159ZM75.9428 14.68L75.9626 14.7128L75.9626 14.7128L75.9428 14.68ZM75.8715 14.706L75.8631 14.6687L75.7297 14.6991L75.8595 14.7423L75.8715 14.706ZM75.9245 14.7302L75.9019 14.7611L75.9021 14.7613L75.9245 14.7302ZM75.9567 14.7648L75.9268 14.7886L75.9271 14.7889L75.9567 14.7648ZM75.9854 14.8056L75.9512 14.8227L75.9514 14.8231L75.9854 14.8056ZM76.0836 14.9961V15.0344H76.1464L76.1176 14.9786L76.0836 14.9961ZM75.8541 14.9961L75.8204 15.0143L75.8312 15.0344H75.8541V14.9961ZM75.7456 14.7952L75.7117 14.8131L75.7119 14.8134L75.7456 14.7952ZM75.7088 14.7446L75.7312 14.7136L75.7306 14.7132L75.7088 14.7446ZM75.6411 14.7293V14.6911H75.6029V14.7293H75.6411ZM75.6411 14.9961V15.0344H75.6794V14.9961H75.6411ZM75.6411 14.6052H75.6029V14.6434H75.6411V14.6052ZM75.7805 14.5962L75.773 14.5587L75.7722 14.5589L75.7805 14.5962ZM75.8133 14.5756L75.7832 14.552L75.7828 14.5525L75.8133 14.5756ZM75.8061 14.4886L75.7814 14.5178L75.8061 14.4886ZM75.6411 14.4716V14.4333H75.6029V14.4716H75.6411ZM75.4754 14.9961V14.3389H75.3989V14.9961H75.4754ZM75.4371 14.3771H75.7756V14.3006H75.4371V14.3771ZM75.7756 14.3771C75.837 14.3771 75.8803 14.3825 75.9077 14.3914L75.9313 14.3186C75.8924 14.306 75.8397 14.3006 75.7756 14.3006V14.3771ZM75.9077 14.3914C75.9327 14.3995 75.9527 14.4143 75.9683 14.4369L76.0312 14.3933C76.0062 14.3573 75.9726 14.332 75.9313 14.3186L75.9077 14.3914ZM75.9684 14.437C75.9835 14.4585 75.992 14.4859 75.992 14.5213H76.0685C76.0685 14.4731 76.0567 14.4296 76.0311 14.3931L75.9684 14.437ZM75.992 14.5213C75.992 14.5523 75.9854 14.5769 75.9739 14.5966L76.04 14.6352C76.0595 14.6018 76.0685 14.5633 76.0685 14.5213H75.992ZM75.974 14.5965C75.9618 14.6171 75.9451 14.634 75.923 14.6473L75.9626 14.7128C75.995 14.6932 76.021 14.6673 76.0399 14.6354L75.974 14.5965ZM75.9231 14.6473C75.9106 14.6548 75.8911 14.6623 75.8631 14.6687L75.88 14.7433C75.9123 14.736 75.9404 14.7262 75.9626 14.7128L75.9231 14.6473ZM75.8595 14.7423C75.8826 14.75 75.8957 14.7566 75.9019 14.7611L75.947 14.6993C75.9311 14.6877 75.909 14.6782 75.8836 14.6697L75.8595 14.7423ZM75.9021 14.7613C75.9048 14.7632 75.9127 14.7709 75.9268 14.7886L75.9867 14.7409C75.9727 14.7234 75.959 14.708 75.9468 14.6992L75.9021 14.7613ZM75.9271 14.7889C75.9411 14.8062 75.9484 14.8171 75.9512 14.8227L76.0196 14.7884C76.0129 14.7749 76.001 14.7586 75.9864 14.7406L75.9271 14.7889ZM75.9514 14.8231L76.0496 15.0136L76.1176 14.9786L76.0194 14.788L75.9514 14.8231ZM76.0836 14.9578H75.8541V15.0344H76.0836V14.9578ZM75.8877 14.9779L75.7792 14.7771L75.7119 14.8134L75.8204 15.0143L75.8877 14.9779ZM75.7794 14.7774C75.7655 14.751 75.7498 14.727 75.7312 14.7136L75.6864 14.7756C75.6894 14.7777 75.6982 14.7875 75.7118 14.8131L75.7794 14.7774ZM75.7306 14.7132C75.7093 14.6984 75.685 14.6911 75.659 14.6911V14.7676C75.6701 14.7676 75.679 14.7705 75.687 14.776L75.7306 14.7132ZM75.659 14.6911H75.6411V14.7676H75.659V14.6911ZM75.6029 14.7293V14.9961H75.6794V14.7293H75.6029ZM75.6411 14.9578H75.4371V15.0344H75.6411V14.9578ZM75.6411 14.6434H75.7267V14.5669H75.6411V14.6434ZM75.7267 14.6434C75.7409 14.6434 75.763 14.6393 75.7889 14.6335L75.7722 14.5589C75.7449 14.565 75.7311 14.5669 75.7267 14.5669V14.6434ZM75.788 14.6337C75.8108 14.6292 75.8298 14.6171 75.8438 14.5987L75.7828 14.5525C75.78 14.5562 75.7772 14.5578 75.773 14.5587L75.788 14.6337ZM75.8434 14.5992C75.8574 14.5812 75.8645 14.5602 75.8645 14.5375H75.788C75.788 14.5434 75.7864 14.5478 75.7832 14.552L75.8434 14.5992ZM75.8645 14.5375C75.8645 14.5075 75.8546 14.4795 75.8308 14.4594L75.7814 14.5178C75.7845 14.5204 75.788 14.525 75.788 14.5375H75.8645ZM75.8308 14.4594C75.8177 14.4483 75.8015 14.4421 75.7855 14.4385C75.7692 14.4348 75.7506 14.4333 75.7303 14.4333V14.5098C75.7471 14.5098 75.7597 14.5111 75.7687 14.5131C75.7779 14.5152 75.7811 14.5175 75.7814 14.5178L75.8308 14.4594ZM75.7303 14.4333H75.6411V14.5098H75.7303V14.4333ZM75.6029 14.4716V14.6052H75.6794V14.4716H75.6029Z"
          fill="#16293C"
        />
      </g>
      <defs>
        <clipPath id="clip0_1338_220582">
          <rect
            width="75.9948"
            height="24"
            fill="white"
            transform="translate(0.613281 0.835938)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

ActiveDutyPageIncome.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
};

export default memo(ActiveDutyPageIncome);
